import { ContinuingEducationCourse } from './continuingEducationCourse'
import { FeathersModel } from './feathersModel'
import { User } from './user'
import { Assistant } from './assistant'
import { Contract } from './contract'
import { WorkerAllocation } from './worker-allocation'
import { DateUtils } from '../services/date-utils.service'
import { createIntlComparer, DEFAULT_LOCALES } from '../services/utils'

export class Worker extends FeathersModel {
  static serviceName = 'workers'

  static intlSortComparer = createIntlComparer(DEFAULT_LOCALES, {
    sensitivity: 'accent',
  })

  userId: string
  contracts: Contract[] = []
  hasTrainingAsWorkerInSocialServices: boolean
  hasTrainingAsSocialWorker: boolean
  user: User
  assistant?: Partial<Assistant>

  supervisionHours: number | null
  isStrong: boolean
  isAdvanced: boolean
  hasHbvVaccine: boolean

  keyWorkerId: number | null // flattened
  keyWorker: Worker | null // flattened

  coordinatorNote: string | null // flattened
  deactivatedAt: Date | null // flattened
  deactivationReason: string | null // flattened
  isDeactivated: boolean // flattened

  workerAllocations: WorkerAllocation[]

  continuingEducationCourses: ContinuingEducationCourse[]

  turnSubresourcesIntoFrontendModels() {
    this.user = this.user ? User.createFromProps(User, this.user) : this.user
    this.workerAllocations = (this.workerAllocations ?? []).map((a) =>
      WorkerAllocation.createFromProps(WorkerAllocation, a),
    )

    if (this.contracts && this.contracts.length > 0) {
      const tempc = []
      for (const c of this.contracts) {
        tempc.push(Contract.createFromProps(Contract, c))
      }
      this.contracts = tempc

      const activeContract = Contract.computeCurrentlyActiveContract(this.contracts)
      if (activeContract) {
        this.contracts.find((c) => activeContract.id === c.id).currentlyActive = true
      }
    }
  }

  updateFromProps(props): this {
    super.updateFromProps(props)
    this.flattenWorkerAllocationArrayFields()
    return this
  }

  private flattenWorkerAllocationArrayFields() {
    const a = this.workerAllocations?.[0]
    if (a) {
      this.keyWorkerId = a.keyWorkerId
      this.keyWorker = a.keyWorker ? Worker.createFromProps(Worker, a.keyWorker as Worker) : null

      this.coordinatorNote = a.coordinatorNote
      this.deactivatedAt = a.deactivatedAt
      this.deactivationReason = a.deactivationReason
      this.isDeactivated = a.isDeactivated
    }
  }

  dehydrate<T extends this>(...omit): Partial<T> {
    // Omit fields that were moved to worker_allocations — they are saved separately.
    const allocationFields: (keyof this)[] = [
      'keyWorkerId',
      'keyWorker',
      'coordinatorNote',
      'deactivatedAt',
      'deactivationReason',
      'isDeactivated',
    ]
    return super.dehydrate(...([...omit, ...allocationFields] as (keyof this)[]))
  }

  isInactive() {
    return DateUtils.canBeParsedToDate(this.deactivatedAt)
  }

  static sortByName(a: Worker, b: Worker) {
    return Worker.intlSortComparer(a.user.fullName(), b.user.fullName())
  }

}
